document.addEventListener('DOMContentLoaded', function () {
  var burger = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', mobileNav.classList.contains('is-open'));
    });
  }

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('is-open');
      if (searchBar.classList.contains('is-open')) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  // Product gallery thumbnails
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (!main) return;
      main.src = btn.getAttribute('data-src');
      main.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Variant selection (pill / swatch radios)
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var variantsEl = document.getElementById('ProductVariantsJson');
    if (variantsEl) {
      var variants = JSON.parse(variantsEl.textContent);
      var groups = form.querySelectorAll('[data-option-group]');
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var addBtn = form.querySelector('[data-add-to-cart]');

      function selectedOptions() {
        return Array.from(groups).map(function (g) {
          var checked = g.querySelector('[data-option-input]:checked');
          return checked ? checked.value : null;
        });
      }

      function currentVariant() {
        var opts = selectedOptions();
        return variants.find(function (v) {
          return opts.every(function (o, i) { return v.options[i] === o; });
        });
      }

      function onChange() {
        groups.forEach(function (g) {
          var checked = g.querySelector('[data-option-input]:checked');
          var valEl = g.querySelector('[data-selected-value]');
          if (checked && valEl) valEl.textContent = checked.value;
        });
        var v = currentVariant();
        if (v) {
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = (v.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.shopCurrency || 'USD' });
          if (addBtn) {
            addBtn.disabled = !v.available;
            addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold-out');
          }
        } else if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-label-unavailable');
        }
      }

      form.querySelectorAll('[data-option-input]').forEach(function (r) { r.addEventListener('change', onChange); });
    }

  }

  // Wishlist toggles (product page + cards)
  document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
    btn.addEventListener('click', function () { btn.classList.toggle('active'); });
  });

  // Collection filters: auto-submit on checkbox change
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () { filterForm.submit(); });
    });
    filterForm.querySelectorAll('[data-show-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.previousElementSibling;
        var opening = !btn.classList.contains('is-open');
        list.querySelectorAll('.filter-hidden').forEach(function (li) { li.hidden = !opening; });
        btn.classList.toggle('is-open', opening);
        btn.textContent = opening ? 'Show less' : 'Show more';
      });
    });
  }
});
